<template>
  <b-dropdown-item class="NotificationItem py-2" :style="notification.read_at?.length ? '' : 'background: #f5fafb;'" >
    <div class="notification-item " style=" display: flex; align-items: center;" >
      <div class="image is-48x48 ">
        <template v-if="notification.data.action=='reminder'">
          <AvatarReminder/>
        </template>
        <template v-else-if="notification.data.model == 'Course'">
          <AvatarCourse/>
        </template>
        <template v-else-if="notification.data.model=='Event'">
          <AvatarEvent/>
        </template>
        <template v-else-if="['AssessmentFeedback','JournalFeedback'].includes(notification.data.model)">
          <AvatarFeedback/>
        </template>
        <template v-else-if="['ForumPost','ForumComment'].includes(notification.data.model)">
          <AvatarForum/>
        </template>
        <template v-else-if="notification.data.model=='Assessment'">
          <AvatarTask/>
        </template>
      </div>
      <div class=" pl-4">
        <div>
          <p style="font-weight: 600; font-size: 1rem; color: black;">{{ notification.data.title }}</p>
          <p class="truncated-text mb-1" style="font-weight: 400; font-size: 0.75rem;">{{ notification.data.message }}</p>
          <p class="tag is-light">{{ getHumanReadableDate(notification.created_at) }}</p>
        </div>
      </div>
    </div>
  </b-dropdown-item>
</template>

<script>
import AvatarReminder from "@/components/notifications/AvatarReminder.vue";
import AvatarForum from "@/components/notifications/AvatarForum.vue";
import AvatarFeedback from "@/components/notifications/AvatarFeedback.vue";
import AvatarCourse from "@/components/notifications/AvatarCourse.vue";
import AvatarTask from "@/components/notifications/AvatarTask.vue";
import AvatarEvent from "@/components/notifications/AvatarEvent.vue";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default {
  name: "NotificationItem",
  components: {AvatarEvent, AvatarTask, AvatarCourse, AvatarFeedback, AvatarForum, AvatarReminder},
  props: {
    notification: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods:{
    getHumanReadableDate(arg) {
      return GenexHelperMixins.methods.getHumanReadableDateVersion2(arg);
    },
  }
}
</script>

<style scoped lang="scss">
.NotificationItem {
  white-space: normal ;
  word-wrap: break-word ;
  .truncated-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>